import { useState } from "react";
import { LoadingSpinner } from "../../components/BaseComponents";
import ConfirmationModal from "../../components/BaseComponents/ConfirmationModal";
import PageHeadings from "../../components/BaseComponents/PageHeadings/PageHeadings";
import useApi from "../../hooks/useApi";
import { getCSRFToken } from "../../lib/utils";

type DeletePortfolioModalProps = {
    onClose: () => void,
    onDeleted: () => void
    isOpen?: boolean,
    portfolioId: string,
    portfolioName: string;
};

function DeletePortfolioModal({onClose, onDeleted, isOpen, portfolioId, portfolioName}: DeletePortfolioModalProps) {
    const api = useApi();
    const [loading, setLoading] = useState(false);

    const deletePortfolio = async () => {
        setLoading(true);
        await api.delete(`/portfolios/${portfolioId}`, {
            _csrf: await getCSRFToken(),
        })
        setLoading(false);
        onDeleted();
    }


    return (
        <ConfirmationModal open={!!isOpen} onCancel={onClose} onConfirm={deletePortfolio}>
            <div className="flex flex-col">
                <PageHeadings title={`Delete portfolio ${portfolioName}?`} />
                { loading && <LoadingSpinner /> }
            </div>
        </ConfirmationModal>
    )
}

export default DeletePortfolioModal;
